import React from 'react';
import { ContentState, convertToRaw, EditorState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import './ContentEditor.css';
import { Box, Button, FormGroup, TextField, Typography, useTheme } from '@mui/material';
import { convertFromHTML, convertToHTML } from 'draft-convert';
import DOMPurify from 'dompurify';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import CloseIcon from '@mui/icons-material/Close';

function createMarkup(html: string) {
    return {
        __html: DOMPurify.sanitize(html)
    }
}

type Props = {    
    html: string,    
    onSave: (html: string) => void,
    onClose: () => void
}

const ContentEditor = ({ html, onSave, onClose }: Props) => {
    const theme = useTheme();
        const [editorState, setEditorState] = React.useState(() => EditorState.createEmpty());    

        React.useEffect(() => {
            const blocksFromHTML = convertFromHTML(html);
            setEditorState(EditorState.createWithContent(blocksFromHTML));        
        }, [html])

    console.log(convertToRaw(editorState.getCurrentContent()));

    return <Box sx={{ margin: 5 }}>        
        <Box>
            <Editor
                editorState={editorState}
                onEditorStateChange={setEditorState}
                editorClassName="editor-class"
                toolbarClassName='test'
                editorStyle={{ border: `1px solid ${theme.palette.divider}`, height: '30vh', maxHeight: '30vh', margin: 0 }}
                mention={{
                    separator: ' ',
                    trigger: '#',
                    suggestions: [
                        { text: 'First Name', value: 'FirstName', url: 'firstname' },
                        { text: 'Last Name', value: 'LastName', url: 'lastname' },
                    ]
                }}
            />            
        </Box>
        <Box sx={{ textAlign: 'right', mt: 5 }}>
            <Button size="small" sx={{ mr: 2 }} variant="contained" onClick={onClose} startIcon={<CloseIcon />}>Close</Button>
            <Button size="small" variant="contained" onClick={() => onSave(convertToHTML(editorState.getCurrentContent()))} startIcon={<SaveAltIcon />}>Save</Button>
        </Box>
        {/*<Box>*/}
        {/*    <div*/}
        {/*        className="preview"*/}
        {/*        dangerouslySetInnerHTML={createMarkup(html)}>*/}
        {/*    </div>*/}
        {/*</Box>*/}
    </Box>
}

export { ContentEditor };
export default ContentEditor;